export const soQuy = {
  sections: {
    phieuThuList: { title: 'Phiếu thu' },
    phieuThuDetail: { title: 'Chi tiết phiếu thu' },
    phieuChiList: { title: 'Phiếu chi' },
    phieuChiDetail: { title: 'Chi tiết phiếu chi' },
    soQuyList: { title: 'Sổ quỹ' },
    baoCao: { title: 'Báo cáo sổ quỹ' },
    taiKhoanQuy: { title: 'Tài khoản quỹ' },
  },
  menu: {
    group: 'Sổ quỹ',
    phieuThu: 'Phiếu thu',
    phieuChi: 'Phiếu chi',
    soQuy: 'Sổ quỹ',
    baoCao: 'Báo cáo',
  },
  phieuThu: {
    title: 'Phiếu thu',
    list: 'Danh sách phiếu thu',
    create: 'Tạo phiếu thu',
    update: 'Sửa phiếu thu',
    detail: 'Chi tiết phiếu thu',
    hintMaPhieu: 'Mã phiếu sinh tự động khi lưu.',
    sectionTitles: {
      thongTinPhieu: 'Thông tin phiếu',
      thongTinDoiTuong: 'Thông tin đối tượng',
      thongTinTaiKhoan: 'Thông tin tài khoản',
      thongTinThanhToan: 'Thông tin thanh toán',
      noiDungGhiChu: 'Nội dung & ghi chú',
    },
    fields: {
      maPhieu: 'Mã phiếu',
      thoiGian: 'Thời gian',
      loaiThuChi: 'Loại thu chi',
      doiTuong: 'Đối tượng',
      doiTuongTen: 'Tên đối tượng',
      doiTuongLoai: 'Loại đối tượng',
      taiKhoanQuy: 'Tài khoản quỹ',
      soTien: 'Số tiền',
      noiDung: 'Nội dung',
      ghiChu: 'Ghi chú',
      trangThai: 'Trạng thái',
      nguoiTao: 'Người tạo',
      nguoiDuyet: 'Người duyệt',
      thoiGianTao: 'Ngày tạo',
      thoiGianCapNhat: 'Ngày cập nhật',
      thoiGianDuyet: 'Ngày duyệt',
      lyDoTuChoi: 'Lý do từ chối',
      lyDoHuy: 'Lý do hủy',
      chungTuDinhKem: 'Chứng từ đính kèm',
      doiTuongSdt: 'SĐT đối tượng',
      doiTuongDiaChi: 'Địa chỉ đối tượng',
      soDuTaiThoiDiem: 'Số dư tại thời điểm',
    },
  },
  phieuChi: {
    title: 'Phiếu chi',
    list: 'Danh sách phiếu chi',
    create: 'Tạo phiếu chi',
    update: 'Sửa phiếu chi',
    detail: 'Chi tiết phiếu chi',
    hintMaPhieu: 'Mã phiếu sinh tự động khi lưu.',
    sectionTitles: {
      thongTinPhieu: 'Thông tin phiếu',
      thongTinDoiTuong: 'Thông tin đối tượng',
      thongTinTaiKhoan: 'Thông tin tài khoản',
      thongTinThanhToan: 'Thông tin thanh toán',
      noiDungGhiChu: 'Nội dung & ghi chú',
    },
    fields: {
      maPhieu: 'Mã phiếu',
      thoiGian: 'Thời gian',
      loaiThuChi: 'Loại thu chi',
      doiTuong: 'Đối tượng',
      doiTuongTen: 'Tên đối tượng',
      doiTuongLoai: 'Loại đối tượng',
      taiKhoanQuy: 'Tài khoản quỹ',
      soTien: 'Số tiền',
      noiDung: 'Nội dung',
      ghiChu: 'Ghi chú',
      trangThai: 'Trạng thái',
      nguoiTao: 'Người tạo',
      nguoiDuyet: 'Người duyệt',
      thoiGianTao: 'Ngày tạo',
      thoiGianCapNhat: 'Ngày cập nhật',
      thoiGianDuyet: 'Ngày duyệt',
      lyDoTuChoi: 'Lý do từ chối',
      lyDoHuy: 'Lý do hủy',
      chungTuDinhKem: 'Chứng từ đính kèm',
      doiTuongSdt: 'SĐT đối tượng',
      doiTuongDiaChi: 'Địa chỉ đối tượng',
      soDuTaiThoiDiem: 'Số dư tại thời điểm',
    },
  },
  // Story 3.3 — Trang hợp nhất Sổ quỹ tổng hợp (FR-10).
  // KHÔNG reuse `phieuThu.*` / `phieuChi.*` namespace cho tab/Loại — trang unified có
  // semantic riêng (cả 2 loại trong cùng view). i18n key structure mirror `phieuThu`/`phieuChi`.
  unified: {
    title: 'Sổ quỹ tổng hợp',
    list: 'Sổ quỹ tổng hợp',
    tabs: {
      all: 'Tất cả',
      thu: 'Phiếu thu',
      chi: 'Phiếu chi',
    },
    fields: {
      // Cột "Loại" (ReceiptTypeIndicator ↑/↓) + "Loại thu chi" — chỉ unified dùng (1.9/2.5 dùng 'phieuThu.fields.*').
      loai: 'Loại',
      loaiThuChi: 'Loại thu chi',
    },
    summary: {
      title: 'Tổng thu / Tổng chi / Lũy kế (toàn bộ filter — đã duyệt)',
      tongThu: 'Tổng thu',
      tongChi: 'Tổng chi',
      chenhLech: 'Lũy kế',
    },
  },
  trangThai: {
    NHAP: 'Nháp',
    CHO_DUYET: 'Chờ duyệt',
    DA_DUYET: 'Đã duyệt',
    HUY: 'Đã hủy',
  },
  loai: { THU: 'Thu', CHI: 'Chi' },
  loaiTaiKhoan: {
    TIEN_MAT: 'Quỹ tiền mặt',
    NGAN_HANG: 'Tài khoản ngân hàng',
  },
  doiTuongLoai: {
    KHACH_HANG: 'Khách hàng',
    NHA_CUNG_CAP: 'Nhà cung cấp',
    NGUOI_DUNG: 'Nhân viên',
    TU_DO: 'Tự do',
  },
  actions: {
    luu: 'Lưu nháp',
    luuThayDoi: 'Lưu thay đổi',
    dong: 'Đóng',
    quayLai: 'Quay lại danh sách',
    taoPhieuThu: 'Tạo phiếu thu',
    taoPhieuChi: 'Tạo phiếu chi',
    sua: 'Sửa',
    guiDuyet: 'Gửi duyệt',
    duyet: 'Duyệt',
    tuChoi: 'Từ chối',
    huy: 'Hủy',
    xoa: 'Xóa',
    in: 'In',
    xuatExcel: 'Xuất Excel',
    xem: 'Xem',
    taiLai: 'Tải lại',
    datLaiBoLoc: 'Đặt lại bộ lọc',
  },
  messages: {
    banner: {
      choDuyet: 'Phiếu đang chờ duyệt.',
      daDuyet: 'Phiếu đã được duyệt bởi {nguoiDuyet} lúc {thoiGian}.',
      huy: 'Phiếu đã bị hủy. Lý do: {lyDo}.',
    },
    taoThanhCong: 'Đã tạo phiếu thu {maPhieu}.',
    suaThanhCong: 'Đã cập nhật phiếu thu {maPhieu}.',
    guiDuyetThanhCong: 'Đã gửi yêu cầu duyệt phiếu thu {maPhieu}.',
    duyetThanhCong: 'Đã duyệt phiếu thu {maPhieu}.',
    tuChoiThanhCong: 'Đã từ chối phiếu thu {maPhieu}.',
    huyThanhCong: 'Đã hủy phiếu thu {maPhieu}.',
    loadError: 'Không tải được danh sách phiếu thu.',
    loadErrorChi: 'Không tải được danh sách phiếu chi.',
    chiTietLoadError: 'Không tải được chi tiết phiếu thu.',
    auditLoadError: 'Không tải được lịch sử thao tác.',
    notFound: 'Không tìm thấy phiếu thu.',
    khongCoQuyen: 'Bạn không có quyền thực hiện thao tác này.',
    xungDotVersion: 'Phiếu đã bị thay đổi bởi người khác. Vui lòng tải lại.',
    loiHeThong: 'Lỗi hệ thống. Vui lòng thử lại sau. (Mã lỗi: {code})',
    chuaCoPhieu: 'Chưa có phiếu thu nào.',
    chuaCoPhieuChi: 'Chưa có phiếu chi nào.',
    chuaCoPhieuKhopLoc: 'Không có phiếu nào khớp bộ lọc.',
    chuaCoPhieuKhopLocChi: 'Không có phiếu chi nào khớp bộ lọc.',
    // Story 3.3 — empty state riêng cho trang unified (FR-10).
    // KHÔNG reuse 'chuaCoPhieu' / 'chuaCoPhieuChi' vì ngữ cảnh khác (cả 2 loại trong unified view).
    chuaCoPhieuUnified: 'Chưa có phiếu nào trong sổ quỹ.',
    chuaCoTaiKhoanQuy: 'Chưa có tài khoản quỹ nào. Liên hệ super admin.',
    dangPhatTrien: 'Trang đang được phát triển ({story}).',
    canhBaoSoDuAm: 'Số dư sau khi chi: {soDuSauKhiChi} đ (âm). Vẫn cho phép tạo phiếu, QL sẽ cân nhắc khi duyệt.',
    guiDuyetThanhCongChi: 'Đã gửi yêu cầu duyệt phiếu chi {maPhieu}.',
    duyetThanhCongChi: 'Đã duyệt phiếu chi {maPhieu}.',
    tuChoiThanhCongChi: 'Đã từ chối phiếu chi {maPhieu}.',
    huyThanhCongChi: 'Đã hủy phiếu chi {maPhieu}.',
    xoaThanhCong: 'Đã xóa phiếu thu nháp {maPhieu}.',
    xoaThanhCongChi: 'Đã xóa phiếu chi nháp {maPhieu}.',
    taoThanhCongChi: 'Đã tạo phiếu chi {maPhieu}.',
    suaThanhCongChi: 'Đã cập nhật phiếu chi {maPhieu}.',
    xacNhan: {
      guiDuyet: 'Gửi duyệt phiếu thu {maPhieu}?',
      guiDuyetChi: 'Gửi duyệt phiếu chi {maPhieu}?',
      duyet: 'Duyệt phiếu {maPhieu}? Số dư {taiKhoanQuy} sẽ tăng +{soTien}.',
      duyetChi: 'Duyệt phiếu {maPhieu}? Số dư {taiKhoanQuy} sẽ giảm -{soTien}.',
      duyetChiKhongDuQuy:
        'Quỹ {taiKhoanQuy} chỉ còn {soDu}, không đủ chi {soTien}. Hệ thống sẽ không cho duyệt phiếu này.',
      tuChoi: 'Từ chối phiếu {maPhieu}? Người tạo sẽ nhận thông báo.',
      tuChoiChi: 'Từ chối phiếu chi {maPhieu}? Người tạo sẽ nhận thông báo.',
      huy: 'Hủy phiếu đã duyệt {maPhieu}? Số dư sẽ giảm -{soTien}.',
      huyChi: 'Hủy phiếu chi đã duyệt {maPhieu}? Số dư sẽ được hoàn lại +{soTien}.',
      xoa: 'Xóa phiếu thu nháp {maPhieu}? Phiếu sẽ bị xóa hẳn, không khôi phục được.',
      xoaChi: 'Xóa phiếu chi nháp {maPhieu}? Phiếu sẽ bị xóa hẳn, không khôi phục được.',
    },
  },
  filters: {
    hintSection: 'Bộ lọc phiếu thu',
    hintBody: 'Lọc theo trạng thái, thời gian, tài khoản quỹ, loại thu chi, người tạo, đối tượng.',
    trangThai: 'Trạng thái',
    thoiGian: 'Thời gian',
    taiKhoanQuy: 'Tài khoản quỹ',
    loaiThuChi: 'Loại thu chi',
    nguoiTao: 'Người tạo',
    doiTuong: 'Đối tượng',
    chiNhanh: 'Chi nhánh',
    homNay: 'Hôm nay',
    tuanNay: 'Tuần này',
    thangNay: 'Tháng này',
    quyNay: 'Quý này',
    namNay: 'Năm nay',
    tuyChinh: 'Tùy chỉnh',
    // Story 3.3 — Section "Loại (Thu/Chi)" sidebar (chỉ unified list dùng).
    // KHÔNG dùng `phieuThu.fields.loai` / `phieuChi.fields.loai` vì ngữ nghĩa khác
    // (unified là "filter cả 2 loại" thay vì "trang 1 loại").
    loaiAll: 'Tất cả',
    loaiThu: 'Phiếu thu',
    loaiChi: 'Phiếu chi',
    // Story 3.3 review patch — Section title cho filter sidebar (resolve i18n tautology).
    // Dùng `loaiThuChiSection` để tránh conflict với `fields.loaiThuChi` đã có.
    loaiThuChiSection: 'Loại (Thu/Chi)',
    taiKhoanQuyAll: 'Tất cả tài khoản',
    taiKhoanQuySearch: 'Tìm tài khoản quỹ',
    taiKhoanQuyEmpty: 'Không có tài khoản quỹ',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    loaiThuChiAll: 'Tất cả loại',
    loaiThuChiSearch: 'Tìm loại thu chi',
    loaiThuChiEmpty: 'Không có loại thu chi',
    nguoiTaoAll: 'Tất cả người tạo',
    nguoiTaoSearch: 'Tìm người tạo',
    nguoiTaoEmpty: 'Không có người tạo',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã phiếu, tên đối tượng, nội dung...',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  validation: {
    soTienRequired: 'Vui lòng nhập số tiền.',
    soTienInvalid: 'Số tiền phải lớn hơn 0.',
    taiKhoanQuyRequired: 'Vui lòng chọn tài khoản quỹ.',
    thoiGianRequired: 'Vui lòng chọn thời gian.',
    thoiGianFuture: 'Thời gian không được vượt quá hôm nay.',
    noiDungRequired: 'Vui lòng nhập nội dung.',
    doiTuongIdRequired: 'Vui lòng chọn đối tượng từ danh sách.',
    chuaXacDinhChiNhanh: 'Chưa xác định chi nhánh. Vui lòng liên hệ quản trị viên.',
    lyDoTuChoiRequired: 'Vui lòng nhập lý do từ chối (10–500 ký tự).',
    lyDoHuyRequired: 'Vui lòng nhập lý do hủy (20–500 ký tự).',
    doiTuongTenRequired: 'Vui lòng nhập tên đối tượng (tối thiểu 3 ký tự).',
    lyDoMinLength: 'Tối thiểu {n} ký tự.',
    lyDoMinLengthLabel: 'tối thiểu {n} ký tự',
    // Code review 1.10 patches:
    taiDuLieuThatBai: 'Không tải được dữ liệu. Vui lòng đóng và mở lại form.',
    noiDungQuaDai: 'Nội dung quá dài (tối đa 1000 ký tự).',
    ghiChuQuaDai: 'Ghi chú quá dài (tối đa 2000 ký tự).',
  },
  printTemplate: {
    title: 'PHIẾU THU',
    titleChi: 'PHIẾU CHI',
    ngayThangNam: 'Ngày {ngay} tháng {thang} năm {nam}',
    soTien: 'Số tiền',
    soTienBangChu: 'Số tiền bằng chữ: {chu}',
    nguoiLap: 'Người lập phiếu',
    thuQuy: 'Thủ quỹ',
    nguoiNhan: 'Người nhận tiền',
    keToanTruong: 'Kế toán trưởng',
    giamDoc: 'Giám đốc',
    // Story 3.4 — extend print template (FR-13). 29 key mới.
    printButton: 'In phiếu',
    closeButton: 'Đóng',
    printPreviewTitle: 'Xem trước phiếu in',
    printLoadingData: 'Đang tải dữ liệu in...',
    printNotSupported: 'Trình duyệt không hỗ trợ in. Vui lòng dùng Chrome/Edge/Firefox.',
    printMobileWarning: 'In từ mobile không tối ưu. Vui lòng dùng desktop để có chất lượng in tốt nhất.',
    printErrorLoad: 'Không tải được dữ liệu in. Vui lòng thử lại.',
    printNotFound: 'Không tìm thấy phiếu. Phiếu có thể đã bị xóa hoặc bạn không có quyền truy cập.',
    printCrossTenant: 'Bạn không có quyền in phiếu này (chi nhánh khác).',
    maPhieu: 'Mã phiếu',
    thoiGian: 'Thời gian',
    sdt: 'SĐT',
    diaChi: 'Địa chỉ',
    taiKhoanQuy: 'Tài khoản',
    kemTheo: 'Kèm theo',
    kemTheoEmpty: '—',
    kyGhiRoHoTen: '(Ký, ghi rõ họ tên)',
    nguoiNop: 'Người nộp',
    hoTenNguoiNop: 'Họ tên người nộp',
    hoTenNguoiNhan: 'Họ tên người nhận',
    nguoiDuyet: 'Người duyệt',
    lyDoThu: 'Lý do thu',
    lyDoChi: 'Lý do chi',
    congTy: 'Công ty',
    chiNhanh: 'Chi nhánh',
    qrLabel: 'Mã QR',
    maPhieuQrLabel: 'Mã phiếu: {maPhieu}',
    qrAriaLabel: 'Mã QR chứa mã phiếu {maPhieu}, quét để xác thực',
    empty: '—',
  },
  taiKhoanQuy: {
    title: 'Tài khoản quỹ',
    list: 'Danh sách tài khoản quỹ',
    create: 'Tạo tài khoản quỹ',
    update: 'Sửa tài khoản quỹ',
    fields: {
      ma: 'Mã tài khoản',
      ten: 'Tên tài khoản',
      loai: 'Loại tài khoản',
      soDuBanDau: 'Số dư ban đầu',
      soDuHienTai: 'Số dư hiện tại',
      nganHang: 'Ngân hàng',
      soTaiKhoan: 'Số tài khoản',
      chiNhanh: 'Chi nhánh',
      trangThai: 'Trạng thái',
    },
  },
  audit: {
    title: 'Lịch sử thao tác',
    empty: 'Chưa có lịch sử thao tác.',
    xemTatCa: 'Xem tất cả',
    thucHienBoi: 'bởi {actor}',
    thoiGianKhongHopLe: '--',
    actions: {
      create: 'Tạo phiếu',
      update: 'Cập nhật phiếu',
      submit: 'Gửi duyệt',
      approve: 'Duyệt phiếu',
      reject: 'Từ chối phiếu',
      cancel: 'Hủy phiếu',
      unknown: 'Khác',
    },
  },
  // Story 4.3 — Trang Báo cáo Sổ Quỹ (FR-11 part 1).
  // Namespace `baoCao.*` cho page header + 4 summary cards (số dư đầu kỳ / tổng thu /
  // tổng chi / số dư cuối kỳ) + filter bar + refresh / error state.
  baoCao: {
    soDuDauKy: 'Số dư đầu kỳ',
    tongThu: 'Tổng thu',
    tongChi: 'Tổng chi',
    soDuCuoiKy: 'Số dư cuối kỳ',
    sectionTongHop: 'Tổng hợp kỳ',
    sectionChiTiet: 'Chi tiết phát sinh',
    chenhLech: 'Chênh lệch: {soTien}',
    tongCong: 'Tổng cộng',
    breadcrumbSoQuy: 'Sổ quỹ',
    subtitle: 'Theo dõi dòng tiền chi nhánh trong kỳ',
    chiNhanhHint: 'Chi nhánh hiện tại',
    khongCoThuTrongKy: 'Không có thu trong kỳ này.',
    khongCoChiTrongKy: 'Không có chi trong kỳ này.',
    loadErrorTitle: 'Không tải được báo cáo sổ quỹ.',
    refreshSuccess: 'Đã tải lại báo cáo.',
    xuatExcelDefer: 'Tính năng xuất Excel sẽ có ở phiên bản tiếp theo (Story 4.5).',
    // Story 4.5 — tooltip + aria-label cho nút [📥 Xuất Excel].
    xuatExcelInvalidKy: 'Vui lòng chọn kỳ hợp lệ',
    xuatExcelAriaLabel: 'Xuất báo cáo sổ quỹ ra Excel',
    tu: 'Từ',
    den: 'Đến',
    filterPlaceholder: 'Tìm theo tên tài khoản, số TK...',
    filterTenTaiKhoan: 'Tên tài khoản quỹ',
    filterSoTaiKhoan: 'Số tài khoản',
  },
  summary: {
    tongThu: 'Tổng thu',
    tongChi: 'Tổng chi',
    luyKe: 'Lũy kế',
  },
  labels: {
    lyDo: 'Lý do',
    soDuTaiThoiDiemHint: 'Số dư tài khoản quỹ tính đến thời điểm phát sinh phiếu.',
  },
  aria: {
    trangThai: 'Trạng thái: {label}',
    columnPicker: 'Chọn cột hiển thị',
  },
  // Namespace `bangKe.*` cho 2 bảng kê thu/chi (Story 4.4 — FR-11 part 2).
  bangKe: {
    thuTitle: 'Bảng kê phiếu thu',
    chiTitle: 'Bảng kê phiếu chi',
    columns: {
      maPhieu: 'Mã phiếu',
      thoiGian: 'Ngày',
      loaiThuChi: 'Loại thu chi',
      soTien: 'Số tiền',
      nguoiTao: 'Người tạo',
    },
    emptyThu: 'Không có phiếu thu đã duyệt trong kỳ này.',
    emptyChi: 'Không có phiếu chi đã duyệt trong kỳ này.',
    loadError: 'Không tải được bảng kê. Vui lòng thử lại.',
    refreshSuccess: 'Đã tải lại bảng kê.',
    xemChiTiet: 'Xem chi tiết phiếu {maPhieu}',
    rowsPerPage: 'Số dòng mỗi trang:',
    // P7 (code review D1): clarify bảng kê KHÔNG filter theo tài khoản quỹ (chỉ 4 card tổng hợp filter).
    subtitleAllChiNhanh: 'Bảng kê toàn chi nhánh (không lọc theo tài khoản quỹ đã chọn)',
  },
  // Namespace `bienDong.*` cho biểu đồ biến động số dư (Story 4.4 — FR-11 part 2).
  bienDong: {
    title: 'Biến động thu/chi theo ngày',
    legendThu: 'Thu',
    legendChi: 'Chi',
    legendSoDu: 'Số dư cuối ngày',
    empty: 'Không có dữ liệu biến động trong kỳ này.',
    requireTaiKhoanQuy: 'Vui lòng chọn ít nhất 1 tài khoản quỹ để xem biểu đồ.',
    loadError: 'Không tải được dữ liệu biến động. Vui lòng thử lại.',
    refreshSuccess: 'Đã tải lại biểu đồ.',
    mobileSummary: 'Tổng thu: {tongThu}, Tổng chi: {tongChi}',
  },
  // Namespace `xuatExcel.*` cho flow xuất Excel báo cáo (Story 4.5 — FR-12 wire-up).
  xuatExcel: {
    // AC-3: toast info khi click button.
    dangTaiFile: 'Đang tải file...',
    // AC-1: button text khi loading.
    dangTai: 'Đang tải...',
    // AC-3: toast success sau khi download.
    thanhCong: 'Đã tải xuống file Excel.',
    // AC-4 nhánh 1: network error.
    matKetNoi: 'Mất kết nối. Vui lòng thử lại.',
    // AC-4 nhánh 2: 400 invalid query (BH-SQ-V-009).
    thamSoKhongHopLe: 'Tham số không hợp lệ. Vui lòng kiểm tra kỳ.',
    // AC-4 nhánh 3: 403 forbidden.
    khongCoQuyen: 'Bạn không có quyền xuất Excel.',
    // AC-4 nhánh 4: 500/503 system error (fallback).
    loiHeThong: 'Lỗi hệ thống khi xuất Excel. Vui lòng thử lại.',
  },
  loaiThuChi: {
    listTitle: 'Loại thu chi',
    searchPlaceholder: 'Tìm theo mã hoặc tên...',
    filterLoaiAll: 'Tất cả loại',
    filter: {
      textDetailTitle: 'Bộ lọc chi tiết',
    },
    filterSection: {
      loai: 'Loại',
      tatCa: 'Tất cả',
    },
    empty: 'Chưa có loại thu chi nào.',
    listSummary: 'Tổng {count} loại',
    fields: {
      ma: 'Mã',
      loai: 'Loại',
      ten: 'Tên loại thu chi',
      maHintCreate: 'Để trống sẽ tự sinh (vd {example})',
      maHintEdit: 'Phải bắt đầu bằng {prefix}',
    },
    heThongBadge: 'Hệ thống',
    actions: { taoMoi: 'Tạo mới' },
    titles: {
      create: 'Tạo loại thu chi',
      edit: 'Sửa loại thu chi',
      delete: 'Xóa loại thu chi',
    },
    validation: {
      tenRequired: 'Vui lòng nhập tên loại thu chi',
      maRequired: 'Vui lòng nhập mã loại thu chi',
      maInvalid: 'Mã phải theo dạng THUXXX hoặc CHIXXX (vd THU001)',
      maLoaiMismatch: 'Mã phải bắt đầu bằng {prefix}',
    },
    messages: {
      loadError: 'Không tải được danh sách loại thu chi.',
      createSuccess: 'Đã tạo loại thu chi.',
      createError: 'Không thể tạo loại thu chi.',
      updateSuccess: 'Đã cập nhật loại thu chi.',
      updateError: 'Không thể cập nhật loại thu chi.',
      deleteSuccess: 'Đã xóa loại thu chi.',
      deleteError: 'Không thể xóa loại thu chi.',
      deleteConfirm: 'Xóa loại thu chi "{ten}"?',
    },
  },
}
